module.exports = __webpack_public_path__ + "img/album18_45.eba04f1a.jpg";